import { Col, Row } from "antd";
import React from "react";
import { TagStatus, TextAddress, TextItemDetail1, TextItemDetail2 } from "../style";
import styled from "styled-components";
import { useWindowSize } from "../../../hook/useWindowSize";
import { getClassStatustItemStake } from "../../../utils/hepler";
import { useApp } from "../../../contexts";
import {
  decimalSeparatorByCurrency,
  thousandSeparatorByCurrency,
} from "../../../utils/Currency";
import NumberFormat from "react-number-format";
import { Copy } from "../../../components/Copy";
import { CopyIcon } from "../../../components/Icons/CopyIcon";
const Container = styled.div`
  padding: 0 0 0 0;
  border-bottom: ${(props) =>
    props.isborder === "true" ? "0.5px solid #cccccc" : "none"};
  @media (max-width: 1024px) {
    padding: 18px 0 22px 0;
  }
`;

export const StakeOrderItem = ({
  isborder = "true",
  item,
  onClick,
  onRedeem,
  onClaim,
}) => {
  const { T, getCurrency, addressConnected } = useApp();
  const classStatus = getClassStatustItemStake(item);

  return (
    <Container className="relative" isborder={isborder}>
      <Row
        className="items-center hidden lg:flex gap-4 lg:gap-0 cursor-pointer h-[75px]"
        onClick={() => onClick(item)}
      >
        <Col span={6}>
          <div className="flex items-center gap-[4px]">
            <span className="text-[#000000] text-[16px] lg:text-[18px] lg:leading-[75px]">
              <Copy
                textStyle={{ fontWeight: 400 }}
                cutText={true}
                splitFont={5}
                splitEnd={10}
                numDot={3}
                text={item.fromAddress}
                icon={<CopyIcon />}
              />
            </span>
          </div>
        </Col>
        <Col span={4}>
          <div
            className="flex flex-col items-start gap-2 lg:items-baseline lg:flex-row text-end cursor-pointer px-2"
            onClick={() => onClick(item)}
          >
            <NumberFormat
              className="font-semibold"
              value={Number(item?.amount ?? 0)}
              displayType="text"
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={8}
              suffix=" SGT"
            />
          </div>
        </Col>
        <Col span={5}>
          <div className="flex flex-col items-start gap-2 lg:items-baseline lg:flex-row lg:justify-between text-end px-2">
            <NumberFormat
              className="text-[#F12E11] font-semibold text-left basis-[100px]"
              value={Number(item?.claimAmount ?? 0)}
              displayType="text"
              thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
              decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
              decimalScale={8}
              suffix=" SGT"
            />
            <div className="flex-1 text-left">
              {item?.claimable && !item?.hasClaimed && (
                <button
                  className="border border-solid border-[#F3850F] text-[#F3850F] text-[10px] disabled:border-[#BDBDBD] disabled:text-[#BDBDBD] rounded-lg h-[25px] px-5"
                  disabled={
                    String(addressConnected).localeCompare(
                      item.fromAddress,
                      "en",
                      {
                        sensitivity: "base",
                      }
                    ) !== 0
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    onClaim(item);
                  }}
                >
                  {T("Claim")}
                </button>
              )}
              {item?.hasClaimed && (
                <span className="text-[#818181] font-semibold px-5 text-[10px]">
                  {T("Claimed")}
                </span>
              )}
            </div>
          </div>
        </Col>
        <Col className="text-start lg:text-center" span={3}>
          <div className="flex flex-col gap-2 lg:items-baseline lg:flex-row px-2">
            <TextItemDetail2 className="text-[#000000] leading-[75px]">
              <NumberFormat
                value={Number(item?.year ?? 0)}
                displayType="text"
                thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                decimalScale={2}
                suffix={` ${item.label}`}
              />
            </TextItemDetail2>
          </div>
        </Col>
        <Col className="justify-center flex" span={3}>
          <div className="flex flex-col gap-2 lg:items-baseline lg:flex-row px-2">
            <TagStatus className={classStatus}>{T(classStatus)}</TagStatus>
          </div>
        </Col>
        <Col className="justify-end flex" span={3}>
          <div className="flex flex-col gap-2 lg:items-baseline lg:flex-row px-2">
            {item?.isFinish && !item?.isClose && (
              <button
                className="border-[2px] border-solid border-[#F3850F] text-[#F3850F] rounded-[15px] h-[40px] px-5 disabled:border-[#BDBDBD] disabled:text-[#BDBDBD]"
                disabled={
                  String(addressConnected).localeCompare(
                    item.fromAddress,
                    "en",
                    {
                      sensitivity: "base",
                    }
                  ) !== 0
                }
                onClick={(e) => {
                  e.stopPropagation();
                  onRedeem(item);
                }}
              >
                {T("Redeem")}
              </button>
            )}
          </div>
        </Col>
      </Row>

      {/* mobile */}
      <div className="lg:hidden">
        <Row
          className="items-center gap-[8px] cursor-pointer"
          onClick={() => onClick(item)}
        >
          <Col span={2}>
            <div className="w-[28px] h-[28px] overflow-hidden">
              <img
                className="w-full h-auto"
                src={"assets/images/otc/crypto/sgt.svg"}
                alt="SGT"
              />
            </div>
          </Col>
          <Col span={13}>
            <TextAddress className="text-[#000000] text-[16px] leading-[24px]">
              <Copy
                textStyle={{ fontWeight: 400 }}
                cutText={true}
                splitFont={5}
                splitEnd={5}
                numDot={3}
                text={item.fromAddress}
                icon={<CopyIcon />}
              />
            </TextAddress>
          </Col>
          <Col></Col>
          <Col>
            <TagStatus className={classStatus}>{T(classStatus)}</TagStatus>
          </Col>
        </Row>

        <Row className="items-center mt-[10px] px-8" gutter={[16, 16]}>
          <Col span={12}>
            <div
              className="flex flex-col items-start gap-2 text-start cursor-pointer"
              onClick={() => onClick(item)}
            >
              <TextItemDetail1>{T("Amount")} </TextItemDetail1>
              <TextItemDetail2 weight={600}>
                <NumberFormat
                  value={Number(item?.amount ?? 0)}
                  displayType="text"
                  thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                  decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                  decimalScale={8}
                  suffix=" SGT"
                />
              </TextItemDetail2>
            </div>
          </Col>

          <Col className="text-start" span={12}>
            <div className="flex flex-col gap-2 ">
              <TextItemDetail1>{T("Duration")}</TextItemDetail1>
              <TextItemDetail2>
                <NumberFormat
                  value={Number(item?.year ?? 0)}
                  displayType="text"
                  thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                  decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                  decimalScale={2}
                  suffix={` ${T(item.label)}`}
                />
              </TextItemDetail2>
            </div>
          </Col>
          <Col className="text-start" span={24}>
            <div className="flex flex-col gap-2">
              <TextItemDetail1>{T("Interest Amount")}</TextItemDetail1>
              <TextItemDetail2 weight={600}>
                <div className="flex items-center gap-2">
                  <NumberFormat
                    value={Number(item?.claimAmount ?? 0)}
                    displayType="text"
                    thousandSeparator={thousandSeparatorByCurrency(getCurrency())}
                    decimalSeparator={decimalSeparatorByCurrency(getCurrency())}
                    decimalScale={8}
                    suffix=" SGT"
                  />
                  {item?.claimable && !item?.hasClaimed && (
                    <button
                      className="border border-solid border-[#F3850F] text-[#F3850F] text-[10px] disabled:border-[#BDBDBD] disabled:text-[#BDBDBD] rounded-lg h-[25px] px-5"
                      disabled={
                        String(addressConnected).localeCompare(
                          item.fromAddress,
                          "en",
                          {
                            sensitivity: "base",
                          }
                        ) !== 0
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        onClaim(item);
                      }}
                    >
                      {T("Claim")}
                    </button>
                  )}
                  {item?.hasClaimed && (
                    <span className="text-[#818181] font-semibold px-5 text-[10px]">
                      {T("Claimed")}
                    </span>
                  )}
                </div>
              </TextItemDetail2>
            </div>
          </Col>

          <Col span={24} className="text-end">
            {item?.isFinish && !item?.isClose && (
              <button
                className="text-[10px] border border-solid border-[#F3850F] text-[#F3850F] disabled:border-[#BDBDBD] disabled:text-[#BDBDBD] rounded-[10px] h-[40px] px-5"
                disabled={
                  String(addressConnected).localeCompare(
                    item.fromAddress,
                    "en",
                    {
                      sensitivity: "base",
                    }
                  ) !== 0
                }
                onClick={(e) => {
                  e.stopPropagation();
                  onRedeem(item);
                }}
              >
                {T("Redeem")}
              </button>
            )}
          </Col>
        </Row>
      </div>
    </Container>
  );
};
